module.exports = __webpack_public_path__ + "static/media/pci-dss.780f5b05.png";